'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewWords = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = function (_Component) {
  (0, _inherits3.default)(NewWords, _Component);

  function NewWords() {
    (0, _classCallCheck3.default)(this, NewWords);
    return (0, _possibleConstructorReturn3.default)(this, (NewWords.__proto__ || (0, _getPrototypeOf2.default)(NewWords)).apply(this, arguments));
  }

  (0, _createClass3.default)(NewWords, [{
    key: 'pushTranslation',
    value: function pushTranslation(word, lang) {
      var language = this.props.params.language === undefined ? 'en' : this.props.params.language;
      return '/' + language + '/translate/' + encodeURIComponent(word) + '/' + lang; // replace 'en' code with another one.
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          recentWords = _props.recentWords,
          t = _props.t;


      var language = this.props.params.language;
      return _react2.default.createElement(
        _reactBootstrap.Panel,
        null,
        _react2.default.createElement(
          'h4',
          null,
          t('content.new_words')
        ),
        recentWords !== undefined && recentWords.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            null,
            (language === 'vi' && item.definition || language === 'en') && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  item.word,
                  ' (',
                  item.lang,
                  ')'
                )
              ),
              ' ',
              _react2.default.createElement(
                'span',
                null,
                item.definition && _react2.default.createElement(
                  'span',
                  null,
                  ' ',
                  item.definition.map(function (data) {
                    var shortDefinition = data.definition + ' ' + (data.more_definition !== undefined ? data.more_definition : '');
                    var definition = shortDefinition.trim() !== '' ? shortDefinition.trim() : data.long_definition;
                    return _react2.default.createElement(
                      'span',
                      null,
                      ' ',
                      definition.substring(0, 40),
                      ' '
                    );
                  }),
                  ' '
                ),
                !item.definition && _react2.default.createElement(
                  'span',
                  null,
                  'No definitions'
                )
              ),
              ' ',
              _react2.default.createElement(
                _reactBootstrap.Button,
                { href: _this2.pushTranslation(item.word, item.lang), bsStyle: 'link', onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.props.history.push(_this2.pushTranslation(item.word, item.lang));
                  } },
                'Xem...'
              ),
              _config2.default.is_for_personal_purpose && _react2.default.createElement(
                _reactBootstrap.Button,
                { href: '/newKnowledgeWithAShortSumary/' + item.word + '/' + item.lang, bsStyle: 'link', onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.props.history.push('/newKnowledgeWithAShortSumary/' + item.word + '/' + item.lang);
                  } },
                _config2.default.is_for_personal_purpose && "Create Content"
              )
            )
          );
        })
      );
    }
  }]);
  return NewWords;
}(_react.Component)) || _class);
exports.default = NewWords;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Knowledge/NewWords.js
// module id = 1505
// module chunks = 0